import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ComingSoon from "@/pages/ComingSoon";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#161622", border: "1px solid #242436", color: "#F4F4F6", borderRadius: 0 } }} />
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<ComingSoon />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
